import { useAtom } from '@reatom/npm-react'
import styled, { css } from 'styled-components'

import { dependenciesAtom } from '@root/features/shared/dependencies'
import { useTranslation } from '@root/shared/localization'

import {
  QUALITY_COLOR_MAP,
  QUALITY_TRANSLATION_MAP,
  latencyToQuality,
} from './model'

export const StatusBarLatency = () => {
  const { t } = useTranslation()
  const [dependencies] = useAtom(dependenciesAtom)
  const [socketLatency] = useAtom(dependencies.mainWebsocket.socketLatencyAtom)

  const quality = latencyToQuality(socketLatency)

  return (
    <Root
      css={css`
        --metrics-color: ${QUALITY_COLOR_MAP[quality]};
        --border-color: var(--metrics-color);
      `}
    >
      <Quality>{t(QUALITY_TRANSLATION_MAP[quality])}</Quality>
    </Root>
  )
}

const Root = styled.div`
  color: var(--metrics-color);
  background-color: var(--backgroundA-3);
  border-radius: 4px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-self: end;

  gap: 4px;
  height: 16px;
  text-transform: capitalize;
  padding-inline: 5px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;

  transition: all 0.15s linear;
`

const Quality = styled.span`
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
`
